// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"a58814fe","108":"7318b0d3","148":"d6bdac75","180":"e70f8568","225":"b83f3a09","331":"ddd4b199","404":"a58732ed","409":"8465c74a","416":"43513a34","455":"5011d67f","472":"a5316e14","591":"2e189266","677":"da9aa384","782":"9f95edf0"}[chunkId] + ".chunk.js";
};